import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeSpecimenUploadDialogMessages.cardTitle',
    defaultMessage: 'Specimen di firma',
  },
  cardSubtitle: {
    id: 'homeSpecimenUploadDialogMessages.cardSubtitle',
    defaultMessage:
      'Carica un’immagine (in formato jpeg, jpg o png) o usa la fotocamera per scattare una foto della tua firma leggibile su sfondo bianco',
  },
  cardDisclaimer: {
    id: 'homeSpecimenUploadDialogMessages.cardDisclaimer',
    defaultMessage:
      'Il Cliente conferma che la firma olografa riportata nel file caricato è autentica, è stata apposta di proprio pugno ed è riconducibile al suo autore. L’immagine della firma olografa raccolta sarà utilizzata al fine di verificare le eventuali operazioni disposte in modalità cartacea che farà pervenire',
  },
  uploadLabel: {
    id: 'homeSpecimenUploadDialogMessages.uploadLabel',
    defaultMessage: 'Carica ora',
  },
  takePhotoLabel: {
    id: 'homeSpecimenUploadDialogMessages.takePhotoLabel',
    defaultMessage: 'Scatta ora',
  },
  takePhotoActionLabel: {
    id: 'homeSpecimenUploadDialogMessages.takePhotoActionLabel',
    defaultMessage: 'Scatta foto',
  },
  cameraPermissionLabel: {
    id: 'homeSpecimenUploadDialogMessages.cameraPermissionLabel',
    defaultMessage: 'Permesso fotocamera',
  },
  askCameraPermissionLabel: {
    id: 'homeSpecimenUploadDialogMessages.askCameraPermissionLabel',
    defaultMessage: 'Concedi permesso',
  },
  retryLabel: {
    id: 'homeSpecimenUploadDialogMessages.retryLabel',
    defaultMessage: 'Riprova',
  },
  saveLabel: {
    id: 'homeSpecimenUploadDialogMessages.saveLabel',
    defaultMessage: 'Salva',
  },
  confirmCTA: {
    id: 'homeSpecimenUploadDialogMessages.confirmCTA',
    defaultMessage: 'Conferma',
  },
  successToastTitle: {
    id: 'homeSpecimenUploadDialogMessages.successToastTitle',
    defaultMessage: 'Specimen di firma completato',
  },
  successToastMessage: {
    id: 'homeSpecimenUploadDialogMessages.successToastMessage',
    defaultMessage:
      'Gentile {0} il caricamento dello specimen di firma è avvenuta con successo',
  },
});
